
import { Component, Vue, Watch } from "vue-property-decorator";

import vNavigation from "@/components/vNavigation.vue";
import vHeader from "@/components/vHeader.vue";

import { LOGOUT_USER } from "@/store/ActionTypes";
import { UserTypes } from "@/models/User/UserTypes";

import { CustomersModule } from "../../store/modules/CustomersModule";
import { PartnersModule } from "../../store/modules/PartnersModule";
import { mapState } from "vuex";
import {AccountState} from "@/store/modules/AccountModule";

const REPORT_ROUTE_SEGMENTS = [
  "retention-report",
  "free-trial-usage-report",
  "search_reports",
] as const;

@Component({
  components: {
    vNavigation,
    vHeader,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
      accountState: (state: any) => state.AccountModule,
    }),
  },
})
class Admin extends Vue {
  navigationOpen = false;
  headerOpen = false;
  reportsMenuOpen = false;
  localizationState: any;
  accountState: AccountState;
  // to be accessible in the template
  UserTypes = UserTypes;

  closeMobile() {
    if (
      typeof window.orientation !== "undefined" ||
      navigator.userAgent.indexOf("IEMobile") !== -1
    ) {
      this.closeNavigation();
    }
  }

  logout() {
    this.$store.dispatch(LOGOUT_USER);
  }

  toggleNavigation() {
    if (this.navigationOpen) {
      this.closeNavigation();
    }
    else {
      this.openNavigation();
    }
  }

  openNavigation() {
    this.navigationOpen = true;
  }

  closeNavigation() {
    this.navigationOpen = false;
  }

  toggleHeaderMenu() {
    this.headerOpen = !this.headerOpen;
  }

  toggleReportsMenu() {
    this.reportsMenuOpen = !this.reportsMenuOpen;
  }

  get isReportsRouteActive() {
    return REPORT_ROUTE_SEGMENTS.some((segment) => this.$route.path.endsWith(segment));
  }

  get translations() {
    return this.localizationState.translations;
  }

  created() {
    // Lazy loading of Vuex modules used only on admin panel.
    this.$store.registerModule("CustomersModule", CustomersModule);
    this.$store.registerModule("PartnersModule", PartnersModule);

    // Set language of the validator (out of the box translations)
    let language: string = this.$store.getters.getUserDetails.localization;
    language = language.substring(0, 2);

    if (this.$validator.dictionary.hasLocale(language)) {
      this.$validator.localize(language);
    }
    else {
      import(`vee-validate/dist/locale/${language}`).then((locale) => {
        this.$validator.localize(language, locale);
      });
    }
  }

  mounted() {
    this.reportsMenuOpen = this.isReportsRouteActive;
    Vue.nextTick(() => {
      (<any>$).Pages.initSidebar();
    });
  }

  @Watch("$route.path", { immediate: true })
  onRoutePathChanged() {
    if (this.isReportsRouteActive) {
      this.reportsMenuOpen = true;
    }
  }

  beforeDestroy() {
    // Lazy unloading of Vuex modules used only on admin panel.
    this.$store.unregisterModule("CustomersModule");
    this.$store.unregisterModule("PartnersModule");
  }
}
export default Admin;
